export default {
	name: 'borrowBooks',
	data() {
		return {
			searchText: '',
			searchBookCode: '',
			getCustomer: {},
			getBook: {},
			customer: null,
			books: [],
			borrowCount: 0,

			OperatorID: this.$store.state.user.UserID,
			ShopID: this.$store.state.user.ShopID,
			actioning: false
		}
	},
	created() {
		this.getCustomer = function() {
			this.$request.request({
				url: 'borrowAndReturn/getCustomerByCodeOrPhone',
				data: {
					searchText: this.searchText
				},
				method: 'post'

			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.searchText = this.customer.CustomerPhone;
				} else {
					this.$uil.showMessage({
						text: res.message
					});
					this.searchText = "";
				}
			})
		}

		this.getBook = function() {

			if (this.customer == null) {
				this.$uil.showMessage({
					text: '请先确认会员信息'
				});
				return;
			}
			if (this.customer.areaID != this.$store.state.user.areaID) {
				this.$uil.showMessage({
					text: '非此地区会员'
				});
				return;
			}
			if (this.customer.CustomerState != 1) {
				this.$uil.showMessage({
					text: '会员已经停止服务'
				});
				return;
			}
			if (!this.customer.isEnd) {
				this.$uil.showMessage({
					text: '会员已经停止服务'
				});
				return;

			}

			let booksum = 0;
			for (let i of this.books)
				booksum += i.count;
			if (this.customer.booksCount * 1 + this.customer.returningCount * 1 - this.customer.borrowBooksCount *
				1 == booksum) {
				this.$uil.showMessage({
					text: '不得超过可借数量'
				});
				return;
			}

			this.$request.request({
				url: 'borrowAndReturn/getBookByBookCode',
				data: {
					searchText: this.searchBookCode.trim()
				},
				method: 'post'

			}).then(res => {
				if (res.result) {
					let book = res.book;
					if (book.BooksSate == 2 || book.BooksSate == 1) {
						this.$uil.showMessage({
							text: book.BooksSate == 1 ? '该书已经下架' : '该书已经借出'
						});
						this.searchBookCode = '';
						return;
					}
					if (book.allowCount <= book.orderCount) {
						this.$uil.showMessage({
							text: '该书已被线上预定'
						});
						this.searchBookCode = '';
						return;
					}
					if (book.ShopID != this.ShopID) {
						this.$uil.showMessage({
							text: '该书不在此店铺内'
						});
						this.searchBookCode = '';
						return;
					}
					let addBorrowBook = () => {
						let isAdd = false;
						for (let i of this.books) {
							if (i.BooksID == book.BooksID) {
								for (let j of i.books) {
									if (j.BookDetailID == book.BookDetailID) {
										this.$uil.showMessage({
											text: '该书已经添加至借书单'
										});
										this.searchBookCode = '';
										return;

									}
								}
								i.books.push({
									'BookDetailID': book.BookDetailID,
									'BooksNumCode': book.BooksNumCode,
									'ShopID': book.ShopID,
									'ShopName': book.ShopName,
									'CurrentPlace': book.CurrentPlace,
								});
								i.count++;
								isAdd = true;
								break;
							}
						}
						if (!isAdd) {
							this.books.push({
								'BooksName': book.BooksName,
								'BooksID': book.BooksID,
								'count': 1,
								'books': [{
									'BookDetailID': book.BookDetailID,
									'BooksNumCode': book.BooksNumCode,
									'ShopID': book.ShopID,
									'ShopName': book.ShopName,
									'CurrentPlace': book.CurrentPlace,
								}]
							});

						}
						this.searchBookCode = '';
					}
					if (book.ClassificationID == 5)
						this.$uil.showMessage({
							text: '馆藏书,确认外借？',
							type: 'confirm',
							ok: () => addBorrowBook()
						});
					else
						addBorrowBook();
					this.searchBookCode = '';
				} else {
					this.$uil.showMessage({
						text: res.message
					});
				}
			})


		}
	},
	methods: {
		searchBook(e) {

			if (e.keyCode == 13)
				this.getBook();
		},
		searchCustomers(e) {

			if (e.keyCode == 13)
				this.getCustomer();
		},
		removeBook(index) {
			this.books.splice(index, 1);
		},
		borrowBooks() {
			if (this.actioning) {
				this.$uil.showMessage({
					text: '数据提交中'
				});
				return;
			}
			this.actioning = true;
			let sum = 0;
			for (let i of this.books)
				sum += i.count;

			this.$request.request({
				url: 'borrowAndReturn/borrowBook',
				data: {
					CustomerID: this.customer.CustomerID,
					BorrowCount: sum,
					ShopID: this.ShopID,
					OperatorID: this.OperatorID,
					borrowBook: JSON.stringify(this.books),
				},
				method: 'post'

			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
				this.customer = null;
				this.books = [];
				this.actioning = false;
			});

		}

	},

	computed: {
		borrowCountSum() {
			let sum = 0;
			for (let i of this.books)
				sum += i.count;

			return '合计:' + sum + '本';

		}

	}

}
